export default __webpack_public_path__ + "static/media/Lilyermak_Ermak.a601aafd.png";